import {useListView} from '../../core/ListViewProvider'
import {ContactsListToolbar} from './ContactListToolbar'
import {ContactsListGrouping} from './ContactsListGrouping'
import {ContactsListSearchComponent} from './ContactsListSearchComponent'

const ContactsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='driverd-header d-flex justify-content-between border-0 pt-10 px-10'>
      <ContactsListSearchComponent />
      {/* begin::Contactd toolbar */}
      <div className='contactd-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <ContactsListGrouping /> : <ContactsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Contactd toolbar */}
    </div>
  )
}

export {ContactsListHeader}
